/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateAssetFileDto { 
    name?: string;
    size?: number;
    mimetype?: string;
    ext?: string;
    /**
     * Name of fallback image in case of banner html asset
     */
    fallbackImg?: string;
    /**
     * Metadata of asset
     */
    metadata?: object;
    assetMedium?: string;
    version?: number;
    annotations?: object;
    annotationsCount?: number;
}

